/**
 * Historial de movimientos de stock (todas las áreas). Cada cambio de stock
 * —creación, ingreso, venta, uso, salida, ajuste, anulación— queda registrado
 * con fecha, cantidad, saldo resultante y quién. Solo lectura desde el front.
 * Además: anular una salida/uso (farmacia/insumos) que devuelve el stock.
 */
import { collection, query, where, orderBy } from 'firebase/firestore';

import { firestore } from './config';
import { USE_API, api, apiQuery } from '@/services/api/client';
import type { Timestamp } from 'firebase/firestore';

export type TipoMovimiento = 'inicial' | 'ingreso' | 'venta' | 'uso' | 'salida' | 'entrega' | 'ajuste' | 'anulacion';

export interface MovimientoStock {
  id: string;
  area: string;
  productoId: string;
  productoNombre?: string | null;
  tipo: TipoMovimiento;
  delta: number;
  stockResultante?: number | null;
  motivo?: string | null;
  refId?: string | null;
  autorUid?: string | null;
  autorNombre?: string | null;
  creadoEn: Timestamp;
}

export function movimientosDe(productoId: string): any {
  if (USE_API) return apiQuery('/movimientos_stock', { producto_id: productoId, _order: '-creado_en' });
  return query(
    collection(firestore, 'movimientos_stock'),
    where('productoId', '==', productoId),
    orderBy('creadoEn', 'desc'),
  );
}

export async function anularSalida(input: { salidaId: string; motivo: string; autorUid: string; autorNombre: string }) {
  if (USE_API) {
    await api.post('/acciones/anular-salida', input);
    return;
  }
  // Firebase no tiene esta acción transaccional; la app usa modo API.
  throw new Error('Anular salida solo disponible en modo API.');
}
